/* istanbul ignore file */
import { prerenderElementsTree, setUnsafeInnerHTML } from './ui-helpers';
import type { UIElement } from '../components/ui-element';
import type { AllowedTagName } from '../components/ui-element.type';

/**
 * @param {string} htmlSource Raw HTML string to be pre-rendered.
 * @param {string} [tagName] Wrapper for HTML tree. Defaults to "div".
 * @returns {string}
 */
export const prerenderHTML = (
    htmlSource: string,
    tagName: AllowedTagName = 'div'
): string => {
    const wrapper: HTMLElement | UIElement = document.createElement(tagName);
    setUnsafeInnerHTML(wrapper, htmlSource);
    prerenderElementsTree(wrapper, true);
    return wrapper.innerHTML;
};

/**
 * @param {string} templateId - id of the template element
 * @param {string} [tagName] Wrapper for HTML tree. It is needed sometimes
 * that some elements aren't allowed markup to build correct DOM tree.
 * Like you cannot insert &lt;tr> inside &lt;div>, but &lt;iframe accepts
 * &lt;tr>. Defaults to div.
 * @deprecated
 * @returns {string}
 */
export const renderVirtualTemplate = (
    templateId: string,
    tagName?: AllowedTagName
): string => {
    const template = document.querySelector(templateId);
    return template ? prerenderHTML(template.innerHTML, tagName) : '';
};
